export enum ActivityStreamItemEventType {
  // Mercer
  EvaluationMember = 'EvaluationMember',
  EvaluationMemberMassUpdate = 'EvaluationMemberMassUpdated',
  JobAssignmentProposal = 'JobAssignmentProposal',
  SpecialPaymentRecord = 'SpecialPaymentRecord',
  SpecialPaymentApproval = 'SpecialPaymentApproval',
  IndividualAllocationValue = 'IndividualAllocationValue',
  EmployeeSnapshotCompensationChanged = 'EmployeeSnapshotCompensationChanged',
  MeritSimulationMemberCalculated = 'MeritSimulationMemberCalculated',
  EmployeeSnapshotManagerChanged = 'EmployeeSnapshotManagerChanged',
  PositionOrganisationAssignmentChanged = 'PositionOrganisationAssignmentChanged',

  // Org Planning
  PositionRecord = 'PositionRecord',
  OrganisationRecord = 'OrganisationRecord',
  EmployeeRecord = 'EmployeeRecord',
  JobAssignmentRecordPositionRecord = 'JobAssignmentRecordPositionRecord',
  JobAssignmentRecordEmployeeRecord = 'JobAssignmentRecordEmployeeRecord',

  // Season
  AutoApproveAllowedChanged = 'AutoApproveAllowedChanged',
  ApprovalRequiredChanged = 'ApprovalRequiredChanged',
  PayrollStateReset = 'PayrollStateReset',
  PayrollExported = 'PayrollExported',
  Record = 'Record',
  SeasonCompensationOverlaid = 'SeasonCompensationOverlaid',
  SeasonBenchmarkUpdateTriggered = 'SeasonBenchmarkUpdateTriggered',
  EmployeeSnapshotDataUpdated = 'EmployeeSnapshotDataUpdated',
  MercerDataTransferred = 'MercerDataTransferred',
  ReassignmentComparisonExecuted = 'ReassignmentComparisonExecuted',
  EmployeeAssignmentsUpdated = 'EmployeeAssignmentsUpdated',
  Letter = 'Letter',

  // Merit Promotion
  PromotionRequested = 'PromotionRequested',
  PromotionDetailsUpdated = 'PromotionDetailsUpdated',
  PromotionRevoked = 'PromotionRevoked',
  PromotionRejected = 'PromotionRejected',
  PromotionAccepted = 'PromotionAccepted',
  PromotionSentForApproval = 'PromotionSentForApproval',
  PromotionFinalized = 'PromotionFinalized',
  PromotionReopened = 'PromotionReopened',
  PromotionReset = 'PromotionReset',

  // Succession Management
  TalentRecommendation = 'TalentRecommendation',
  TalentPoolAssignment = 'TalentPoolAssignment',

  // ECL
  Clause = 'Clause',
  ClauseVersion = 'ClauseVersion',
  ClauseTranslation = 'ClauseTranslation',
  TemplateVersionAcknowledgement = 'TemplateVersionAcknowledgement',
  TemplateVersionAcknowledgementTranslation = 'TemplateVersionAcknowledgementTranslation',
  TemplateVersionHeader = 'TemplateVersionHeader',
  TemplateVersionHeaderTranslation = 'TemplateVersionHeaderTranslation',
  TemplateVersionFooter = 'TemplateVersionFooter',
  TemplateVersionFooterTranslation = 'TemplateVersionFooterTranslation',
  TemplateVersionSettings = 'TemplateVersionSettings',
  Template = 'Template',
  TemplateVersion = 'TemplateVersion',
  TemplateVersionContent = 'TemplateVersionContent',

  // HeadcountApproval
  PositionRequest = 'PositionRequest',
  PositionRequestApproval = 'PositionRequestApproval',

  // Standing Position Evaluation
  StandingPositionEvaluationRequestApproval = 'StandingPositionEvaluationRequestApproval',
  StandingPositionEvaluationRequest = 'StandingPositionEvaluationRequest',
  StandingPositionEvaluationMasterDataJobCode = 'StandingPositionEvaluationMasterDataJobCode',
  StandingPositionEvaluationMasterDataPositionClass = 'StandingPositionEvaluationMasterDataPositionClass',
  StandingPositionEvaluationMasterDataEmployee = 'StandingPositionEvaluationMasterDataEmployee',

  // Organisation Management
  OrganisationManagement = 'OrganisationManagement',
  OrganisationManagementMasterData = 'OrganisationManagementMasterData',
  OrganisationManagementRule = 'OrganisationManagementRule',
  OrganisationManagementMassChange = 'OrganisationManagementMassChange',

  // Exceptional Recognitions
  ExceptionalRecognitionsProposal = 'ExceptionalRecognitionsProposal',
  ExceptionalRecognitionsApproval = 'ExceptionalRecognitionsApproval',
  ExceptionalRecognitionsBoardFlag = 'ExceptionalRecognitionsBoardFlag',
  ExceptionalRecognitionsCfoFlag = 'ExceptionalRecognitionsCfoFlag',
  ExceptionalRecognitionsPayrollExport = 'ExceptionalRecognitionsPayrollExport',
  ExceptionalRecognitionsEmployeeMapping = 'ExceptionalRecognitionsEmployeeMapping',

  // Authorization
  UserActivated = 'UserActivated',
  UserArchived = 'UserArchived',
  UserDeleted = 'UserDeleted',
  UserRoleAssigned = 'UserRoleAssigned',
  UserRoleUnassigned = 'UserRoleUnassigned',
  RuleBasedAccessFilterAssigned = 'RuleBasedAccessFilterAssigned',
  RuleBasedAccessFilterUnassigned = 'RuleBasedAccessFilterUnassigned',
  ClusterNodeAssigned = 'ClusterNodeAssigned',
  ClusterNodeUnassigned = 'ClusterNodeUnassigned',
  RoleCreated = 'RoleCreated',
  RoleUpdated = 'RoleUpdated',
  RoleDeleted = 'RoleDeleted',
  RolePermissionsGranted = 'RolePermissionsGranted',
  RolePermissionsRevoked = 'RolePermissionsRevoked',
  EndpointGroupCreated = 'EndpointGroupCreated',
  EndpointGroupUpdated = 'EndpointGroupUpdated',
  EndpointGroupDeleted = 'EndpointGroupDeleted',
  EndpointGroupCopied = 'EndpointGroupCopied'
}
